export default __webpack_public_path__ + "static/media/banner_wcummins_datos.bec0f142.jpg";